module.exports = __webpack_public_path__ + "img/03873ea0ff7e389946a4764c978db4c6.cceda318.png";